/** Marketing photos in /public/images/product (keep in sync with that folder). */
export const PRODUCT_GALLERY_IMAGES: string[] = [
  "/images/product/bowl-activity.jpeg",
  "/images/product/mug-and-bowl-still-image.jpeg",
  "/images/product/mug-still-shot.jpeg",
  "/images/product/water-pour-activity.jpeg",
];

/** Used for kit gallery / buy-now (product photography only). */
export const FULL_MARKETING_GALLERY_IMAGES: string[] = [...PRODUCT_GALLERY_IMAGES];
